import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import "whatwg-fetch"
import ConnectButtonForm from "../../common/ConnectButtonForm";
import WindowEventHelper from "../../../lib/WindowEventHelper";

class EvernoteForm extends Component {

	componentDidMount() {
		const { plugin, data, onChange } = this.props
		if (!plugin.active) {
			onChange(update(data, {
				setting: {
					imagePreview: {
						$set: '1'
					},
					visible: {
						$set: 'EVERYONE'
					}
				},
				validated: {
					$set: !!data.setting.oAuthConsumerInfo
				}
			}))
		}

		WindowEventHelper.add("message", this.handleReceivePostMessage)
	}

	componentWillUnmount() {
		WindowEventHelper.remove("message", this.handleReceivePostMessage)
	}

	@autobind
	handleConnect() {
		window.open('/oauth/evernote','EvernoteAuth','width=800,height=600,toolbar=no,menubar=no,location=no,scrollbars=no,status=no');
	}

	@autobind
	handleReceivePostMessage(e) {
		const { data, onChange } = this.props

		if (e.data && e.data.name === 'Evernote') {
			onChange(update(data, {
				setting: {
					oAuthConsumerInfo: {
						$set: e.data.oAuthConsumerInfo
					}
				},
				validated: {
					$set: true
				}
			}))
		}
	}

	render() {
		const { data, plugin } = this.props
		return (
			<div className="desc_plugin5">
				<p className="txt_plugin">
					에버노트(Evernote)에서 작성한 노트를 블로그로 불러올 수 있습니다.<br/>
					플러그인을 설정하면 에버노트에서 ‘티스토리’ 태그가 붙은 모든 노트를 목록으로 가져오고, 특정 노트를 선택하면 에티터에 내용을 불러옵니다.
					태그는 티스토리, tistory 한글/영문 대소문자 모두 허용합니다.<a href="https://www.evernote.com" target="_blank" className="link_other">에버노트 바로가기</a>
				</p>
				<p className="txt_other">
					글쓰기의 플러그인에서 Evernote 플러그인을 확인하실 수 있습니다.
				</p>
				<div className="wrap_btn">
					<ConnectButtonForm connected={!!data.setting.oAuthConsumerInfo} onClick={this.handleConnect} />
					<span className="txt_other">연결 페이지가 보이지 않으시면 브라우저의 팝업 허용 여부를 확인해 주세요.</span>
				</div>
                {this.props.saveButton()}
			</div>
		)
	}
}

EvernoteForm.propTypes = {
	plugin: PropTypes.object.isRequired,
	data: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired
}

export default EvernoteForm
